import { InfoBox } from "../../../../../ui/molecules/infoBox"
import { MacrouseReviewDTO } from "../dataservice/dto"

interface Props {
    close?: () => void,
    valuesArray: MacrouseReviewDTO
}

export interface Superficie {
    bio: number
    conversion: number
    convz: number
    tare: number
}

export function ParticelleMacrousePopup(props: Props) {
    const valuesArray = props.valuesArray.parcelsByMacrouse
    const totalSurfaces = ((): Superficie => {
        return {
            bio: valuesArray.map(v => v.bioArea).reduce((b1, b2) => b1 + b2, 0),
            conversion: valuesArray.map(v => v.inConversioneArea).reduce((c1, c2) => c1 + c2, 0),
            convz: valuesArray.map(v => v.convenzionaleArea).reduce((c1, c2) => c1 + c2, 0),
            tare: valuesArray.map(v => v.naArea).reduce((t1, t2) => t1 + t2, 0)
        }
    })()

    return (
        <div>
            <div className="p-[24px]">
                <InfoBox
                    title="Macrouso per superficie"
                    color="green"
                    table={{
                        title: null,
                        headers: ['Macrouso', 'Superficie Biologico', 'Superifice Conversione', 'Superficie Convenzionale', 'Tare'],
                        values: [
                            ...valuesArray.map(surfaces => [
                                surfaces.macrouseIdentifier + " - "+surfaces.speciesIdentifier,
                                String(surfaces.bioArea),
                                String(surfaces.inConversioneArea),
                                String(surfaces.convenzionaleArea),
                                String(surfaces.naArea)
                            ]),
                            [
                                'Totale per superficie',
                                String(totalSurfaces.bio),
                                String(totalSurfaces.conversion),
                                String(totalSurfaces.convz),
                                String(totalSurfaces.tare)
                            ]
                        ]
                    }}
                />

                <div className="pt-5">
                    <InfoBox 
                        color="green"
                        content={[
                            {title: 'Totale macrousi', label: String(totalSurfaces.bio + totalSurfaces.conversion + totalSurfaces.convz + totalSurfaces.tare)},
                            {title: 'Totale SAU', label: String(totalSurfaces.bio + totalSurfaces.conversion + totalSurfaces.convz)}
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}